import React from 'react';
import { classList } from '../../../utils/string.ts';

export type PhoneLinkProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  phone: string;
  className?: string;
};

export const PhoneLink: React.FunctionComponent<PhoneLinkProps> = props => {
  const { phone, className, ...htmlAttributes } = props;
  const formattedPhone = phone.replace(/\s+/g, ''); // Remove spaces for the tel link

  return (
    <a
      {...htmlAttributes}
      href={`tel:${formattedPhone}`}
      className={classList(
        'text-sk-red-500 focus-visible:text-sk-red-900 hover:text-sk-red-900 cursor-pointer text-sm',
        className
      )}
    >
      {phone}
    </a>
  );
};
